import React from 'react'
import { NavLink } from 'react-router-dom'
import adminStyles from './adminStyles.module.css'

const AdminSidebar = () => {
  return (
    <div>
        <ul>
            <li>
                <NavLink to=''>Add Treatment</NavLink>
            </li>

               <li>
                <NavLink to='deletetreatment'>Delete/Edit Treatment</NavLink>
            </li>

               <li>
                <NavLink to='addlocation'>Add Location</NavLink>
            </li>

               <li>
                <NavLink to='deletelocation'>Delete/Edit Location</NavLink>
            </li>


  <li>
                <NavLink to='adddoctor'>Add Doctor</NavLink>
            </li>

               <li>
                <NavLink to='deletedoctor'>Delete/Edit Doctor</NavLink>
            </li>


               <li>
                <NavLink to='addoffer'>Add Offer</NavLink>
            </li>

               <li>
                <NavLink to='deleteoffer'>Delete Offer</NavLink>
            </li>

               <li>
                <NavLink to='bookappointmentdata'>Book Appointment Data</NavLink>
            </li>

        </ul>
    </div>
  )
}

export default AdminSidebar